const ctaBlocks = document.getElementsByClassName('cta-block');
if(ctaBlocks.length > 0) {
    const randomArrayKey = Math.floor(Math.random() * ctaBlocks.length);
    ctaBlocks[randomArrayKey].removeAttribute('hidden');
}
